import React, {useEffect} from 'react';
import classNames from "classnames";
import { Breadcrumbs, BreadcrumbItem } from '../../ui/Breadcrumbs';

import styles from './PageLayout.module.css';

interface PageLayoutProps {
    children: React.ReactNode;
    breadcrumbs?: BreadcrumbItem[];
    className?: string;
    size?: string;
}

export const PageLayout: React.FC<PageLayoutProps> = ({
    children,
    breadcrumbs,
    className,
    size = '',
}) => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className={classNames(styles.page, className)}>
            <div className="container">
                {breadcrumbs && breadcrumbs.length > 0 && (
                    <div className={classNames(styles.breadcrumbsWrapper, styles[`breadcrumbsWrapper_${size}`])}>
                        <Breadcrumbs items={breadcrumbs} />
                    </div>
                )}
                {children}
            </div>
        </main>
    );
};